const addInfo = {
  title: 'GreenFleetDashboard',
  icon: 'green-fleet-dashboard'
}
const greenFleetDashboardRouter = {
  path: '/green-fleet-dashboard',
  meta: {
    title: 'GreenFleetDashboard',
    icon: 'green-fleet-dashboard',
    permission: ['green_fleet_dashboard']
  },
  children: [
    // {
    //   path: 'internal-combustion-engine-vehicles',
    //   component: () => import('@/views/GreenFleetDashboard/internal-combustion-engine-vehicles'),
    //   name: 'InternalCombustionEngineVehicles',
    //   meta: { title: 'InternalCombustionEngineVehicles', parent: addInfo }
    // },
    {
      path: 'internal-combustion-engine-vehicles',
      component: () => import('@/views/GreenFleetDashboard/InternalCombustionEngineVehicle/internal-combustion-engine-vehicles'),
      name: 'InternalCombustionEngineVehicles',
      meta: { title: 'GreenFleetDashboard', parent: addInfo, permission: ['green_fleet_dashboard'] }
    },
    // {
    //   path: 'electric-vehicles',
    //   component: () => import('@/views/GreenFleetDashboard/ElectricVehicle/electric-vehicles'),
    //   name: 'ElectricVehicles',
    //   meta: { title: 'ElectricVehicles', parent: addInfo },
    // },
  ]
}

export default greenFleetDashboardRouter